import React from 'react';
import ReactECharts from 'echarts-for-react';
import type { ChartDataPoint } from '@/store/metrics/types';

interface InsightChartProps {
  data: ChartDataPoint[];
}

const InsightChart: React.FC<InsightChartProps> = ({ data }) => {
  const option = {
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderColor: '#e2e8f0',
      borderWidth: 1,
      textStyle: {
        color: '#334155',
      },
      formatter: (params: { name: string; value: number }[]) => {
        const dataPoint = params[0];

        return `
          <div style="padding: 8px;">
            <div style="font-weight: 600; margin-bottom: 4px;">${dataPoint.name}</div>
            <div style="color: #3b82f6;">Value: ${dataPoint.value}</div>
          </div>
        `;
      },
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: data.map((item) =>
        item.period.toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
        }),
      ),
      axisLine: {
        lineStyle: {
          color: '#e2e8f0',
        },
      },
      axisLabel: {
        color: '#64748b',
        fontSize: 12,
      },
    },
    yAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: '#e2e8f0',
        },
      },
      axisLabel: {
        color: '#64748b',
        fontSize: 12,
      },
      splitLine: {
        lineStyle: {
          color: '#f1f5f9',
        },
      },
    },
    series: [
      {
        type: 'line',
        data: data.map((item) => item.value),
        smooth: true,
        lineStyle: {
          color: '#1f2937',
          width: 3,
        },
        itemStyle: {
          color: '#1f2937',
        },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(55, 65, 81, 0.3)', // gray-700 with 30% opacity
              },
              {
                offset: 1,
                color: 'rgba(249, 250, 251, 0.05)', // gray-50 with 5% opacity
              },
            ],
          },
        },
        symbol: 'circle',
        symbolSize: 6,
        emphasis: {
          itemStyle: {
            color: '#1d4ed8',
            borderColor: '#ffffff',
            borderWidth: 2,
          },
        },
      },
    ],
    animation: true,
    animationDuration: 1000,
    animationEasing: 'cubicOut',
  };

  return (
    <div className='h-64 w-full'>
      <ReactECharts
        option={option}
        style={{ height: '100%', width: '100%' }}
        opts={{ renderer: 'canvas' }}
      />
    </div>
  );
};

export default InsightChart;
